import { db } from 'boot/firebase';
import { collection } from 'firebase/firestore';

import GenericDB from './generic-db';

export default class ProgramFormItemsDB extends GenericDB {
  constructor(programId = null) {
    super('', 'programs.programFormItems');
    this.setProgramId(programId);
  }

  setProgramId(programId) {
    this.programId = programId;
  }

  getCollectionRef() {
    return collection(db, 'programs', this.programId, 'programFormItems');
  }
}
